import { CubicBezier } from "../../../d3-mapp/curve/bezier.js";
import { getValueNeighborhood } from "./spline-neighborhood.js";
export const getValue = (milli, time, data, codec, averageDataInterval, gapDetectionThreshold, targetInterval, from, alternatives) => {
    const result = {
        value: null,
        from,
    };
    const closeProximity = Math.min(averageDataInterval, targetInterval); //maybe even divide this value by 2
    const neighborhood = getValueNeighborhood(milli, time, data, gapDetectionThreshold, closeProximity, from, alternatives);
    if (neighborhood) {
        const { s1, s0, e0, e1 } = neighborhood;
        if (e0 && e0.t === milli) {
            //spot on match!!
            result.value = e0.v;
            result.from = e0.i; //next time we call this function with t1 >= t start at this index
        }
        else {
            let bc;
            if (s1 && s0 && e0 && e1) {
                // s1 -> s0 -> e0 -> e1 is defined full spline section
                bc = codec.spline(s1, s0, e0, e1, targetInterval);
            }
            else if (s1 && s0 && e0 && !e1) {
                // s1 -> s0 -> e0 is defined
                bc = codec.spline(s1, s0, e0, undefined, targetInterval);
            }
            else if (!s1 && s0 && e0 && e1) {
                //s0 -> e0 -> e1 is defined
                bc = codec.spline(undefined, s0, e0, e1, targetInterval);
            }
            else if (!s1 && s0 && e0 && !e1) {
                //s0 -> e0 is defined
                bc = codec.spline(undefined, s0, e0, undefined, targetInterval);
            }
            else if (s1 && s0 && !e0 && !e1) {
                //s1 -> s0 is defined -> extrapolate right from s1 - s0
                bc = codec.spline(undefined, s1, s0, undefined, targetInterval);
            }
            else if (!s1 && s0 && !e0 && !e1) {
                //only s0 is defined
                bc = codec.spline(undefined, s0, undefined, undefined, targetInterval);
            }
            else if (!s1 && !s0 && e0 && e1) {
                //e0 -> e1 is defined -> extrapolate left from e0 - e1
                bc = codec.spline(undefined, e0, e1, undefined, targetInterval);
            }
            else if (!s1 && !s0 && e0 && !e1) {
                //only e0 is defined
                bc = codec.spline(undefined, undefined, e0, undefined, targetInterval);
            }
            if (bc) {
                result.value = getSplineValue(milli, bc);
            }
            result.from = s0 ? s0.i : from; //next time we call this function with t1 >= t start at this index
        }
    }
    return result;
};
const getSplineValue = (milli, spline) => {
    if (spline.length === 0) {
        return null;
    }
    else {
        let bc = spline[0];
        if (spline.length > 1) {
            let i = 0;
            while (i < spline.length && milli > CubicBezier.getEnd(spline[i]).x)
                i++;
            bc = spline[i < spline.length ? i : i - 1];
        }
        const t = CubicBezier.tForX(bc, milli);
        if (t.length > 0) {
            return CubicBezier.get(bc, t[0]).y;
        }
        else {
            return null;
        }
    }
};
